import { createSlice } from "@reduxjs/toolkit";

export const loanProviderSlice = createSlice({
  name: "filters",
  initialState: {
    activeFilter: {
      parameter: "status",
      value: 1,
      index: 0,
    },
  },
  reducers: {
    setFilters: (state, action) => {
      return { ...state, activeFilter: action.payload };
    },
    ResetLoanProviderFilter: () => {
      return {
        activeFilter: {
          parameter: "status",
          value: 1,
          index: 0,
        }
      }
    }
  },
});

export const { setFilters, ResetLoanProviderFilter } = loanProviderSlice.actions;

export default loanProviderSlice.reducer;
